module.exports = __webpack_public_path__ + "static/5-5-20835f9a35507d2a0783b7dd320b6e97.png";